"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelTypeFromCollectionName = exports.getCollectionNameFromModelType = void 0;
var collections_1 = require("@livv/models/collections");
var modelType_1 = require("@livv/models/modelType");
var getCollectionNameFromModelType = function (type, documentId) {
    switch (type) {
        case modelType_1.ModelType.ANALYSIS:
            return collections_1.CollectionName.ANALYSES;
        case modelType_1.ModelType.ARTICLE:
            return collections_1.CollectionName.ARTICLES;
        case modelType_1.ModelType.DECISION:
            return collections_1.CollectionName.DECISIONS;
        case modelType_1.ModelType.GLOSSARY_TERM:
            return collections_1.CollectionName.GLOSSARY_TERMS;
        case modelType_1.ModelType.LAW_TEXT:
            return documentId.startsWith('LEGIARTI')
                ? collections_1.CollectionName.CODE_ARTICLES
                : collections_1.CollectionName.LAW_TEXTS;
        case modelType_1.ModelType.PUBLICATION_SHEET:
            return collections_1.CollectionName.PUBLICATION_SHEETS;
        case modelType_1.ModelType.STATISTIC:
            return collections_1.CollectionName.STATISTICS;
        default:
            throw Error("Collection not found for model type ".concat(type, "."));
    }
};
exports.getCollectionNameFromModelType = getCollectionNameFromModelType;
var getModelTypeFromCollectionName = function (collection) {
    switch (collection) {
        case collections_1.CollectionName.ANALYSES:
            return modelType_1.ModelType.ANALYSIS;
        case collections_1.CollectionName.ARTICLES:
            return modelType_1.ModelType.ARTICLE;
        case collections_1.CollectionName.DECISIONS:
            return modelType_1.ModelType.DECISION;
        case collections_1.CollectionName.GLOSSARY_TERMS:
            return modelType_1.ModelType.GLOSSARY_TERM;
        case collections_1.CollectionName.CODE_ARTICLES:
        case collections_1.CollectionName.LAW_TEXTS:
            return modelType_1.ModelType.LAW_TEXT;
        case collections_1.CollectionName.PUBLICATION_SHEETS:
            return modelType_1.ModelType.PUBLICATION_SHEET;
        case collections_1.CollectionName.STATISTIC_ENTRIES:
        case collections_1.CollectionName.STATISTICS:
            return modelType_1.ModelType.STATISTIC;
        default:
            throw Error("Model not found for collection ".concat(collection, "."));
    }
};
exports.getModelTypeFromCollectionName = getModelTypeFromCollectionName;
//# sourceMappingURL=collection.js.map